/**
 * Raund-v2 セマンティックカラートークン
 *
 * Figma の `color.figma` から抽出。Mantine に依存しない純粋定数なので
 * React アプリ・Storybook・E2E テストなど全ての環境から import 可能。
 *
 * @example
 * // E2E / テストでの色値検証
 * import { raundColors } from '@/theme/colors'
 * expect(element).toHaveStyle({ backgroundColor: raundColors.primary.base })
 */
export const raundColors = {
  /** Primary — Yellow (#FFC500) */
  primary: {
    base: '#FFC500',
    hover: '#E0AC00',
    active: '#C99700',
    light: '#FFF4CC',
    tint: '#FFFAE6',
    border: '#FFE08A',
    text: '#000000',
  },

  /** Secondary — Orange (#FF8A00) */
  secondary: {
    base: '#FF8A00',
    hover: '#E67700',
    active: '#CC6900',
    light: '#FFE8CC',
    tint: '#FFF5E6',
    border: '#FFD9A3',
    text: '#000000',
  },

  /** Tertiary — Green (#5BBF3A) */
  tertiary: {
    base: '#5BBF3A',
    hover: '#4DA532',
    active: '#3F8C2A',
    light: '#E6F6E1',
    tint: '#F2FBF0',
    border: '#CDEBC3',
    text: '#000000',
  },

  /** System — Gray (汎用 UI 状態色) */
  system: {
    base: '#757575',
    hover: '#616161',
    active: '#424242',
    light: '#E0E0E0',
    tint: '#EEEEEE',
  },

  /** System/Success — Green (#2FA36B) */
  success: {
    base: '#2FA36B',
    light: '#DDF3E8',
    tint: '#EEF9F3',
  },

  /** System/Info — Blue (#3B82C4) */
  info: {
    base: '#3B82C4',
    light: '#E1EEF8',
    tint: '#F0F6FC',
  },

  /** System/Warning — Orange (#E6A23C) */
  warning: {
    base: '#E6A23C',
    light: '#FCEFD8',
    tint: '#FEF7EC',
  },

  /** System/Danger — Red (#D46A6A) */
  danger: {
    base: '#D46A6A',
    hover: '#C55757',
    active: '#AD4343',
    light: '#F6E2E2',
    tint: '#FBF1F1',
  },

  /** 固定色 */
  black: '#000000',
  white: '#FFFFFF',
  grey: '#CBCBCE',

  /** テキスト標準色 */
  textPrimary: '#161722',
} as const

export type RaundColors = typeof raundColors
